import type { FundAccountSelection, StatementPeriod } from '../types/dealerFundStatementPeriod.types';
import { periodQueryParams, recentMonths, STATEMENT_MONTH_OPTIONS, validateRange } from './statementPeriod';

export const periodSearchParams = (period: StatementPeriod): URLSearchParams =>
    new URLSearchParams(periodQueryParams(period));

const parseMonth = (month: string, todayIso: string): StatementPeriod | null =>
    recentMonths(todayIso, STATEMENT_MONTH_OPTIONS).includes(month) ? { kind: 'month', month } : null;

const parseRange = (from: string, to: string, todayIso: string): StatementPeriod | null =>
    validateRange(from, to, todayIso) === null ? { kind: 'range', from, to } : null;

export const parsePeriodSearch = (
    params: URLSearchParams,
    todayIso: string,
    rangeAllowed: boolean,
): StatementPeriod | null => {
    const month = params.get('month');
    const from = params.get('from');
    const to = params.get('to');
    if (month !== null) return from === null && to === null ? parseMonth(month, todayIso) : null;
    if (from === null || to === null || !rangeAllowed) return null;
    return parseRange(from, to, todayIso);
};

export const dealerFinancialsTabPath = (dealerId: string): string => `/admin/dealers/${dealerId}?tab=financials`;

export const fundAccountStatementPath = (
    dealerId: string,
    selection: FundAccountSelection,
    period: StatementPeriod,
): string =>
    `/admin/dealers/${dealerId}/fund-accounts/${selection.sellingDealerId}/${selection.productId}/statement?${periodSearchParams(period)}`;
